import React from "react"
import PropTypes from "prop-types"
import { breakpoints } from "../../../theme"
import styled from "styled-components"

const Grid = styled.div`
  max-width: 100%;
  display: grid;
  grid-gap: ${props =>
    props.$gap === "small"
      ? "10px"
      : props.$gap === "medium"
      ? "20px"
      : props.$gap === "xlarge"
      ? "35px"
      : props.$gap === "xxlarge"
      ? "55px"
      : "24px"};

  @media (min-width: ${breakpoints.medium}px) {
    grid-template-columns: repeat(${props => props.$count}, 1fr);
  }
`

const Columns = ({ count, contents, children, gap }) => {
  return (
    <Grid $count={count} $gap={gap}>
      {children ||
        contents.map((item, i) => (
          <div key={i}>
            {item.title && <h3>{item.title}</h3>}
            {item.content && <div>{item.content}</div>}
          </div>
        ))}
    </Grid>
  )
}

Columns.propTypes = {
  gap: PropTypes.oneOf(["small", "medium", "large", "xlarge", "xxlarge"]),
  count: PropTypes.number,
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
    })
  ),
}

Columns.defaultProps = {
  count: 2,
  gap: "large",
}

export { Columns }
